import { type Store, createLens } from '@frontend/viewer-core';

import type {
  DxfSessionState,
  EntityHighlights,
  HighlightManager,
} from './types';

const NO_HIGHLIGHTS: EntityHighlights = new Map();

export const createHighlightsSlice = (
  state: Store<DxfSessionState>,
): Store<EntityHighlights> =>
  createLens(
    state,
    (current) => current.highlights,
    (current, highlights) => ({ ...current, highlights }),
  );

const hasSameHighlights = (a: EntityHighlights, b: EntityHighlights) =>
  a.size === b.size && [...a].every(([key, color]) => b.get(key) === color);

type Dependencies = {
  highlights: Store<EntityHighlights>;
};

export const createHighlightController = ({
  highlights,
}: Dependencies): HighlightManager => ({
  getState: highlights.getState,
  subscribe: highlights.subscribe,

  set(next) {
    // Equal contents keep the old reference, so subscribers see no change.
    highlights.setState((previous) =>
      hasSameHighlights(previous, next) ? previous : new Map(next),
    );
  },

  clear() {
    highlights.setState((previous) =>
      previous.size === 0 ? previous : NO_HIGHLIGHTS,
    );
  },
});
